import { useCallback } from 'react';

import type { GlobalShortcutsItem } from '@atlassian/global-shortcuts';

import type { NavItemConfig } from '../../../../common/types';
import { getMenuNameAndIcon } from '../../../../common/utils/get-menu-name-and-icon';

export const useGetMenuNameAndIcon = (
	items: Record<string, NavItemConfig>,
	shortcuts: Record<string, GlobalShortcutsItem>,
) =>
	useCallback((menuId: string) => getMenuNameAndIcon(items, shortcuts)(menuId), [items, shortcuts]);
